import {SecurityRequestBase} from '@/oauth/SecurityRequestBase';
import {Authority} from '@/oauth/Authority';
import {getModule} from 'vuex-module-decorators';
import {AuthStore} from '@/oauth/AuthStore';


export class AuthorityDto {
    private static url = '/api/authority';
    
    public static async findByAuthority(authority: string): Promise<Authority> {
        const fullUrl = this.url + '/' + authority;
        const response = await SecurityRequestBase.postWithToken<Authority>(fullUrl);
        return response as Authority;
    }
    
    public static async getAllAuthorities(): Promise<Authority[]> {
        const response = await SecurityRequestBase.getDataWithJwt(this.url + '/all', {});
        const list = response.map((a: Authority) => {
            return Authority.of(a);
        });
        getModule(AuthStore).setAuthorities(list);
        return list;
    }
    
    public static async addAuthority(a: Authority) {
        const response = await SecurityRequestBase.postWithToken(this.url + '/save', a);
        const authority = await response as Authority;
        return Authority.of(authority);
    }
    
    public static async deleteAuthority(a: Authority) {
        await SecurityRequestBase.postWithToken(this.url + '/del', a);
        return true;
    }
}

